<template>
	<div class="listModeSchedule-page" :style="{ height: $pageHeight() + 'px' }">
		<topBar :scheduleMode="'list'" @switchScheduleMode="switchScheduleMode" :userId="userId"
			@showHideHomeMenu="showHideHomeMenu" @showHideSearchBar="showHideSearchBar"></topBar>
		<div class="listMode">
			<div class="listModule-menu" v-show="isShowListModuleMenu">
				<memberMenu :memberList="memberList" :userId="userId" :viewUserId="viewUserId"></memberMenu>
			</div>
			<div class="listModeSchedule">
				<searchBar v-show="isShowSearchBar"></searchBar>
				<div class="schedule-area">
					<scheduleBar :memberList="memberList" :switchMode="2"></scheduleBar>
					<div class="schedule-area-list" v-show="!noData">
						<scheduleList :memberList="memberList" :viewUserId="viewUserId" :currentPage="currentPage"
							:isSearchMode="isShowSearchBar" :userId="userId">
						</scheduleList>
					</div>
					<div class="schedule-noData" v-show="noData">
						<img src="../../assets/common/scheduleListNoData.png" />
					</div>
					<div class="schedule-area-pagination" v-show="!noData">
						<el-pagination background layout="prev, pager, next" :total="totalItems"
							@current-change="changeCurrentPage">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import topBar from '../../components/common/TopBar.vue';
	import memberMenu from '../../components/common/MemberMenu.vue';
	import scheduleBar from '../../components/tools/ScheduleBar.vue';
	import searchBar from '../../components/tools/SearchBar.vue';
	import scheduleList from '../../components/schedule/ScheduleList.vue';
	export default {
		components: {
			topBar,
			memberMenu,
			searchBar,
			scheduleBar,
			scheduleList
		},
		props: {},
		data() {
			return {
				isShowSearchBar: false, //是否展示搜索栏
				isShowListModuleMenu: true, //是否展示列表模式菜单
				memberList: [], //人员管理列表
				userId: -1, //当前登录用户Id
				viewUserId: -1, //当前查看的用户Id
				totalItems: 0, //请求的日程列表数据总条数
				currentPage: 1, //当前页数
				noData: true, //是否没有数据
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				let userInfo = JSON.parse(localStorage.getItem('userInfo'));
				that.userId = userInfo.id;
				that.viewUserId = that.userId;
				that.getServicePersonInfo();
				that.$bus.$on('getScheduleList', (scheduleList) => {
					that.totalItems = scheduleList.totalItems;
				})
				if (that.$route.params.isShowSearchBar) {
					that.isShowSearchBar = that.$route.params.isShowSearchBar;
				}
				that.$bus.$on('selectViewUser', (userInfo) => {
					let that = this;
					if (userInfo) {
						that.viewUserId = userInfo.id;
					} else {
						that.viewUserId = that.userId;
					}
				})
				that.$bus.$on('noData', (noData) => {
					that.noData = noData;
				})
			})
		},
		methods: {
			//获取当前用户服务对象列表
			getServicePersonInfo() {
				let that = this;
				let params = {
					userId: that.userId
				};
				that.$api.getServicePersonInfo(params).then(res => {
					// console.log(res)
					if (res.code == 1) {
						res.data.forEach((item, index) => {
							item.isSelected = false;
						});
						res.data = res.data.filter(item => {
							return item.id != that.userId
						});
						that.memberList = res.data;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//点击切换日程显示模式
			switchScheduleMode() {
				let that = this;
				that.$router.replace("/home");
			},
			//点击显示隐藏搜索栏
			showHideSearchBar() {
				let that = this;
				that.isShowSearchBar = !that.isShowSearchBar;
			},
			//点击切换当前页
			changeCurrentPage(e) {
				let that = this;
				that.currentPage = e;
			},
			//点击展示隐藏首页左侧菜单栏
			showHideHomeMenu(isShowListModuleMenu) {
				let that = this;
				that.isShowListModuleMenu = isShowListModuleMenu;
			},
		},
	}
</script>

<style lang="scss">
	.listMode {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;

		.listModule-menu {
			height: 100%;
		}
	}

	.listModeSchedule {
		width: 100%;
	}

	.schedule-area {

		.schedule-area-list {}

		.schedule-noData {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			img {}
		}

		.schedule-area-pagination {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
		}
	}

	@media screen and (min-width: 1024px) {
		.schedule-area {
			padding: 14px 22px 19px;
		
			.schedule-area-list {
				margin: 19px 0 0;
			}
		
			.schedule-noData {
				padding: 36px 0 0;
				img {
					height: 400px;
				}
			}
		
			.schedule-area-pagination {
				padding: 20px 0 0;
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.schedule-area {
			padding: 24px 40px 40px;

			.schedule-area-list {
				margin: 40px 0 0;
			}

			.schedule-noData {
				padding: 60px 0 0;
				img {
					height: 600px;
				}
			}

			.schedule-area-pagination {
				padding: 33px 0 0;
			}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>